<template>
  <section>
    <h4 class="form-card-header">{{ $t('registration.pip-info') }}</h4>
    <div class="form-card-form ">
      <div>
        <label for="pi_pip">{{ $t('registration.pip') }}:<span class="text-danger">*</span></label>
        <select id="pi_pip"
                v-model="form.isPip"
                name="is_pep"
                class="form-select dropdown-color">
          <option v-for="item in pipStatus" :key="item.id" :value="item.id">{{ item.label }}</option>
        </select>
        <div class="error-message" v-show="v$.form.isPip.$errors.length">
          <div v-show="!v$.form.isPip.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>
    </div>

    <!--      <div v-if="form.isPip === 1">-->
    <!--        <label for="pi_pip_info" class="block text-sm font-medium text-gray-700">{{ $t('registration.pip-detail') }}</label>-->
    <!--        <textarea class="pi-input pt-3 pb-3"-->
    <!--                  name="is_pep_real"-->
    <!--                  id="pi_pip_info"-->
    <!--                  rows="3"-->
    <!--                  v-model="form.pipInfo"></textarea>-->
    <!--        <div class="error-message" v-show="error[1]">-->
    <!--          <div>{{ $t('helper.please-fill') }} {{ $t('helper.text-count', { slot: '200' }) }}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <div class="form-card-form mt-4">
      <div v-if="form.isPip === 1">
        <label for="pi_pip_lastname">{{ $t('registration.lastname') }}:<span class="text-danger">*</span></label>
        <input id="pi_pip_lastname"
               size="sm"
               type="text"
               class="pi-input"
               v-model="v$.pipNotes.pipLastname.$model"
               @input="setPipInfo">
        <div class="error-message" v-show="v$.pipNotes.pipLastname.$errors.length">
          <div v-show="!v$.pipNotes.pipLastname.$errors.required">{{ $t('helper.name-regex') }}
            {{ $t('helper.text-count', {slot: '30'}) }}
          </div>
        </div>
      </div>

      <div v-if="form.isPip === 1">
        <label for="pi_pip_firstname">{{ $t('registration.firstname') }}:<span class="text-danger">*</span></label>
        <input id="pi_pip_firstname"
               size="sm"
               type="text"
               class="pi-input"
               v-model="v$.pipNotes.pipFirstname.$model"
               @input="setPipInfo">
        <div class="error-message" v-show="v$.pipNotes.pipFirstname.$errors.length">
          <div v-show="!v$.pipNotes.pipFirstname.$errors.required">{{ $t('helper.name-regex') }}
            {{ $t('helper.text-count', {slot: '30'}) }}
          </div>
        </div>
      </div>

      <div v-if="form.isPip === 1">
        <label for="pi_pip_position">{{ $t('registration.pip-position') }}:<span class="text-danger">*</span></label>
        <input id="pi_pip_position"
               size="sm"
               type="text"
               class="pi-input"
               v-model="v$.pipNotes.pipPosition.$model"
               @input="setPipInfo">
        <div class="error-message" v-show="v$.pipNotes.pipPosition.$errors.length">
          <div v-show="!v$.pipNotes.pipPosition.$errors.required">{{ $t('helper.name-regex') }}
            {{ $t('helper.text-count', {slot: '100'}) }}
          </div>
        </div>
      </div>

      <div v-if="form.isPip === 1">
        <label for="pi_pip_relative">{{ $t('registration.pip-relative') }}:<span class="text-danger">*</span></label>
        <input id="pi_pip_relative"
               size="sm"
               type="text"
               class="pi-input"
               v-model="v$.pipNotes.pipRelative.$model"
               @input="setPipInfo">
        <div class="error-message" v-show="v$.pipNotes.pipRelative.$errors.length">
          <div v-show="!v$.pipNotes.pipRelative.$errors.required">{{ $t('helper.name-regex') }}
            {{ $t('helper.text-count', {slot: '20'}) }}
          </div>
        </div>
      </div>

      <input type="hidden" name="pep_notes" :value="form.pipInfo" />

      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i
            class="sr sr-chevron-left"></i>{{ $t('button.previous') }}
        </ic-button>
        <ic-button size="tn" type="button" variant="success" @click="next()" class="d-flex align-items-center ml-3">
          {{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>
  </section>
</template>

<script>
import {required, maxLength, requiredIf} from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import {nameRegexValidator} from '../../mixins/regex'

export default {
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      pipStatus: [{id: 1, label: 'тийм'}, {id: 0, label: 'үгүй'}],
      error: [false, false],
      form: {
        isPip: null,
        pipInfo: null,
      },
      pipNotes: {
        pipLastname: null,
        pipFirstname: null,
        pipPosition: null,
        pipRelative: null,
      }
    }
  },
  validations() {
    if (this.form.isPip === 1) {
      return {
        form: {
          isPip: {required},
          pipInfo: {max: maxLength(200)},
        },
        pipNotes: {
          pipLastname: {required, nameRegexValidator},
          pipFirstname: {required, nameRegexValidator},
          pipPosition: {required, nameRegexValidator},
          pipRelative: {required, nameRegexValidator}
        }
      }
    } else {
      return {
        form: {
          isPip: {required},
          pipInfo: {max: maxLength(200)},
        }
      }
    }
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${this.$('helper.please-fill-required-fields')}`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    setPipInfo() {
      this.form.pipInfo = this.pipNotes.pipRelative + " - " + this.pipNotes.pipLastname + " " + this.pipNotes.pipFirstname + " : " + this.pipNotes.pipPosition;
    }
  },
}
</script>

